import $ from 'jquery';

function initPricingPlans() {
    $('.pricing-plans').each(function () {
        let $block = $(this);
        let currency = "eur";
        
        $block.find('#pricing-plans-switch').on('change', function () {
            let $this = $(this);

            if ($this.is(':checked')) {
                $block.find('.price-item').hide();
                $block.find('.price__yearly[data-currency="'+currency+'"]').show();
                $block.find('.switch-monthly').removeClass('active');
                $block.find('.switch-yearly').addClass('active');
            } else {
                $block.find('.price-item').hide();
                $block.find('.price__monthly[data-currency="'+currency+'"]').show();
                $block.find('.switch-monthly').addClass('active');
                $block.find('.switch-yearly').removeClass('active');
            }
        } );
        $block.find('.switch-monthly').on('click', function () {
            $block.find('#pricing-plans-switch').prop('checked', false).trigger('change');
        });
        $block.find('.switch-yearly').on('click', function () {
            $block.find('#pricing-plans-switch').prop('checked', true).trigger('change');
        });

        $block.find('input[name="currency"]').on('change' , function () {
            currency = $(this).val();
            $block.find('.price-item').hide();
            if ($block.find('#pricing-plans-switch').is(':checked')) {
                $block.find('.price__yearly[data-currency="'+currency+'"]').show();
            } else {
                $block.find('.price__monthly[data-currency="'+currency+'"]').show();
            }
        });
        
    });
}

export { initPricingPlans };